import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {CountUp} from 'countup.js';

jQuery(document).ready(function () {
    initBurgerMenu();
    //slider();
    dropdown();
    video();
    initBackToTop();
    scrollAnimations();
    countUp();
    initBrowserCheck();
    initFlowchartAnimation();
    kennzahlenAnimation();
    lottieInSwiper();
    lottieStories();
});

function initBurgerMenu() {
    const button = jQuery('.burger-menu');
    const navContainer = jQuery('.navi');
    const navlink = jQuery('.navi a');

    button.on('click', function () {
        button.toggleClass('active');
        navContainer.toggleClass('active');
        jQuery('body').toggleClass('noscroll');
    })
    navlink.on('click', function () {
        button.toggleClass('active');
        navContainer.toggleClass('active');
        jQuery('body').removeClass('noscroll');
    })

    jQuery('body').on('click', function (e) {
        if (jQuery('.navi.active').length > 0 && !navContainer.is(e.target) && navContainer.has(e.target).length === 0 && !button.is(e.target) && button.has(e.target).length === 0) {
            navContainer.removeClass('active');
            button.removeClass('active');
            jQuery('body').removeClass('noscroll');
        }
    });

}

/*function slider() {
    const numberswiper = new Swiper('.numbers_swiper', {
        // Optional parameters
        modules: [Navigation],
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 45,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        // Navigation arrows
    });
    let postone = jQuery('.gesamtbank').data('count');
    let posttwo = jQuery('.gesamtbank').data('count') + jQuery('.kunden').data('count');
    let postthree = jQuery('.gesamtbank').data('count') + jQuery('.kunden').data('count') + jQuery('.mitarbeiter').data('count');
    numberswiper.on('transitionEnd', function () {
        let currentSlide = numberswiper.realIndex;
        jQuery('.swiper_menu a').removeClass('active');
        if (currentSlide < postone) {
            if (!jQuery('.gesamtbank').hasClass('active')) {
                jQuery('.gesamtbank').addClass('active');
            }
        } else if (currentSlide < posttwo) {
            if (!jQuery('.kunden').hasClass('active')) {
                jQuery('.kunden').addClass('active');
            }
        } else if (currentSlide < postthree) {
            if (!jQuery('.mitarbeiter').hasClass('active')) {
                jQuery('.mitarbeiter').addClass('active');
            }
        } else {
            if (!jQuery('.region').hasClass('active')) {
                jQuery('.region').addClass('active');
            }
        }
    });
    jQuery('.gesamtbank').on('click', function (e) {
        e.preventDefault();
        numberswiper.slideToLoop(0, 0);
    });

    jQuery('.kunden').on('click', function (e) {
        e.preventDefault();
        numberswiper.slideToLoop(postone, 0);
    });

    jQuery('.mitarbeiter').on('click', function (e) {
        e.preventDefault();
        numberswiper.slideToLoop(posttwo, 0);
    });

    jQuery('.region').on('click', function (e) {
        e.preventDefault();
        numberswiper.slideToLoop(postthree, 0);
    });

    const valueswiper = new Swiper('.values_swiper', {
        // Optional parameters
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: true,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                centeredSlides: true,
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });
    if (jQuery('.values_swiper').length > 0) {
        jQuery('.values_swiper .swiper-slide-active lottie-player').get(0).play();
    }
    jQuery('.values_swiper .swiper-button-prev.enabled').click(function () {
        jQuery('.values_swiper .swiper-slide-active lottie-player').get(0).stop();
        setTimeout(function () {
            jQuery('.values_swiper .swiper-slide-active lottie-player').get(0).play();
        }, 100);
    });
    jQuery('.values_swiper .swiper-button-next.enabled').click(function () {
        jQuery('.values_swiper .swiper-slide-active lottie-player').get(0).stop();
        setTimeout(function () {
            jQuery('.values_swiper .swiper-slide-active lottie-player').get(0).play();
        }, 100);
    });

    jQuery('.swiper-button-prev.enabled').click(function () {
        jQuery(".swiper-button").removeClass("enabled");
        valueswiper.slidePrev();
        setTimeout(function () {
            jQuery('.swiper-slide').removeClass('hide');
        }, 100);

    });
    jQuery('.swiper-button-next.enabled').click(function () {
        jQuery(".swiper-button").removeClass("enabled");
        valueswiper.slideNext();
        setTimeout(function () {
            jQuery(".swiper-button").addClass("enabled");
        }, 100);
    });
    valueswiper.on('transitionStart', function () {
        jQuery('.swiper-slide').addClass('hide');
    });
    valueswiper.on('transitionEnd', function () {
        jQuery('.swiper-slide').removeClass('hide');
    });
}*/

function dropdown() {
    for (const dropdown of document.querySelectorAll(".custom-select-wrapper")) {
        dropdown.addEventListener('click', function () {
            this.querySelector('.custom-select').classList.toggle('open');
        })
    }
    for (const option of document.querySelectorAll(".custom-option")) {
        option.addEventListener('click', function () {
            if (!this.classList.contains('selected')) {
                this.parentNode.querySelector('.custom-option.selected').classList.remove('selected');
                this.classList.add('selected');
                this.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = this.textContent;
            }
            let value = jQuery(this).attr("data-value");
            jQuery.ajax({
                type: 'POST',
                url: ajax.url,
                dataType: 'json',
                data: {
                    action: 'get_numbers',
                    value: value,
                },
                success: function (data, textStatus, XMLHttpRequest) {
                    console.log(data);
                    if (data) {
                        jQuery('.mobile .numbers').html(data.html);
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log(errorThrown);
                }
            })
        })
    }
    window.addEventListener('click', function (e) {
        for (const select of document.querySelectorAll('.custom-select')) {
            if (!select.contains(e.target)) {
                select.classList.remove('open');
            }
        }
    });
}

function video() {
    jQuery('.play').on('click', function (e) {
        jQuery('.video_modal').addClass("active");
    });
    jQuery('.close').on('click', function (e) {
        jQuery('.video_modal').removeClass("active");
        jQuery('.video_modal video').trigger('pause');
    });
}

function initBackToTop() {
    jQuery(document).on('scroll', function () {
        var scroll = jQuery(document).scrollTop();
        var viewheight = jQuery(window).height();
        var fullheight = document.body.scrollHeight;
        if (scroll > ((fullheight - viewheight) * 0.25)) {
            jQuery('.back-to-top').fadeIn("slow");
        }
        if (scroll < ((fullheight - viewheight) * 0.25)) {
            jQuery('.back-to-top').fadeOut("slow");
        }
    });
    jQuery('.back-to-top').on('click', function (event) {
        jQuery('html, body').stop().animate({
            scrollTop: jQuery('body').offset().top
        }, 1000);
    });
}

function scrollAnimations() {
    jQuery(document).on('scroll', function (event) {
        let scroll = jQuery(window).scrollTop();
        if (scroll > 600) {
            jQuery('.vorwort_text').addClass('active');
        }
        if (scroll > 1400) {
            jQuery('.stories_text').addClass('active');
        }
        if (scroll > 4100) {
            jQuery('.kennzahlen_text').addClass('active');
        }
        if (scroll > 5100) {
            jQuery('.heads_text').addClass('active');
        }
        if (scroll > 6100) {
            jQuery('.values_text').addClass('active');
        }
        if (scroll > 6900) {
            jQuery('.thanks_text').addClass('active');
        }
    });
}


function countUp() {
    let doneTheStuff = false;

    jQuery(document).on('scroll', function () {
        let scroll = jQuery(window).scrollTop();

        if (!doneTheStuff && scroll > 4100) {
            jQuery('.kennzahl').each(function (index, el) {
                const raw = jQuery(el).text().replace(/\./g, '').trim();
                const number = parseInt(raw);

                if (!isNaN(number)) {
                    const countup = new CountUp(el, number, {
                        separator: '.',
                        duration: 1.5
                    });

                    if (!countup.error) countup.start();
                    else console.error('CountUp error:', countup.error);
                }
            });

            doneTheStuff = true;
        }
    });
}


// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        var ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if (isIE()) {
        jQuery('.ie-check').show();
    }
}


function initFlowchartAnimation() {
    $('.flowchart_desktop, .flowchart_tablet').each(function () {
        const $container = $(this);
        const $section = $('#flowchart');
        const $startImg = $container.find('.flow-start');
        const $video = $container.find('.flow-video');
        const $endImg = $container.find('.flow-end');
        let hasPlayed = false;

        function isInViewport($el) {
            const rect = $el[0].getBoundingClientRect();
            return rect.top < $(window).height() * 0.6;
        }

        function checkScroll() {
            if (!hasPlayed && isInViewport($section)) {
                hasPlayed = true;
                $startImg.hide();
                $video.show().trigger('play');

                $video.on('ended', function () {
                    $video.hide();
                    $endImg.show();
                });
            }
        }

        $(window).on('scroll', checkScroll);
        $(window).on('load', checkScroll);
    });
}


function kennzahlenAnimation() {
    jQuery('.numbers_box').hover(
        function () {
            const player = jQuery(this).find('lottie-player').get(0);
            player.stop();
            player.play();
        },
        function () {
            const player = jQuery(this).find('lottie-player').get(0);
            player.stop();
        }
    );
}

function lottieInSwiper() {
    const valueswiper = new Swiper('.values_swiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: true,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            slideChangeTransitionEnd: function () {
                const currentPlayer = document.querySelector('.swiper-slide-active lottie-player');
                if (currentPlayer) {
                    currentPlayer.play();
                }
            }
        }
    });

    valueswiper.init();
}

function lottieStories() {
    window.addEventListener("load", function () {
        const boxes = document.querySelectorAll(".dark-story-icon");

        boxes.forEach(box => {
            const player = box.querySelector(".lottie-hover");

            if (player && typeof player.play === "function") {
                box.addEventListener("mouseenter", () => {
                    player.play();
                });

                box.addEventListener("mouseleave", () => {
                    player.stop();
                });
            }
        });
    });
}